import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {GlobalsService} from '@services/globals.service';
import {TranslateService} from "@ngx-translate/core";
import {LanguagesInt} from "@interfaces/";
import { Router } from '@angular/router';
import {AdminService} from "@services/admin.service";
/**
  Componente que permite al usuario seleccionar un idioma de una lista de opciones.
  Este componente muestra una lista de idiomas disponibles, filtra los idiomas aceptados
  según la configuración del administrador y emite un evento cuando se selecciona un idioma.
  También permite navegar a una página de información.
**/
@Component({
    selector: 'app-choose-language',
    templateUrl: './choose-language.component.html',
    styleUrls: ['./choose-language.component.scss'],
    standalone: false
})
export class ChooseLanguageComponent implements OnInit {
    /**
    Lista de idiomas disponibles, filtrados según los idiomas aceptados por el administrador.
    @type {Array<any>}
  **/
    languages: Array<any> = [];

    /**
      Indica si se debe mostrar el botón de cierre en el componente.
      @type {boolean}
      @default true
    **/
    @Input() showClose = true;
  
    /**
      Evento que se emite cuando se selecciona un idioma.
      @type {EventEmitter<any>}
    **/
    @Output() select: EventEmitter<any>;
  constructor(private  globals: GlobalsService,
              private translate: TranslateService,
              private _admin: AdminService,
              private router: Router,
  ) {
    const langAccepted = this._admin.admin.LOCALES;
    this.languages =  globals.languages
      .filter((res) => langAccepted.indexOf(res.text) > -1);
    this.select = new EventEmitter<any>();
  }

  ngOnInit(): void {
  }
    /**
    Maneja la selección de un idioma.
    Actualiza el idioma seleccionado en los servicios globales y en el servicio de traducción,
    y emite el evento `select` con el idioma seleccionado.
    @param {LanguagesInt} language - Idioma seleccionado.
    @return void
  **/
  onSelectLanguage(language: LanguagesInt): void {
    this.globals.languageSelected = language;
    this.translate.use(language.id);
    this.select.emit(language);
  }

  openModal(): void {
    this.router.navigate(['information'])
  }

}
